import styled from 'styled-components';

const Title = styled('div')`
  position: absolute;
  bottom: calc(100% - 15px);
  width: 100%;
`;

export default Title;
